import { computed, toRefs } from 'vue'

import { GaButtonBase } from '../button-base'
import { GaIcon } from '../icon'
import { GaLinkBase } from '../link-base'

import { BORDER_WIDTH, ICON_SIZE, SIZE, STATE, VIEW } from './scripts/const'

// @vue/component
export default {
  name: 'ga-button-icon-only',

  components: {
    GaIcon,
  },

  inheritAttrs: false,

  props: {
    /** Внешний вид кнопки */
    view: {
      type: String,
      default: VIEW.MAIN,
      validator: (value) => Object.values(VIEW).includes(value),
    },
    /** Размер кнопки */
    size: {
      type: String,
      default: SIZE.M,
      validator: (value) => Object.values(SIZE).includes(value),
    },
    /** Размер иконки */
    iconSize: {
      type: String,
      default: ICON_SIZE.M,
      validator: (value) => Object.values(ICON_SIZE).includes(value),
    },
    /** Добавляет анимацию загрузки */
    loading: {
      type: Boolean,
      default: false,
    },
    /** Убирает интерактивность */
    disabled: {
      type: Boolean,
      default: false,
    },
    /** Изменяет ширину рамки, работает только при view line */
    borderWidth: {
      type: String,
      default: BORDER_WIDTH.M,
      validator: (value) => Object.values(BORDER_WIDTH).includes(value),
    },
    /** Делает кнопку круглой  */
    round: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { attrs }) {
    const { view, size, iconSize, loading, disabled, borderWidth, round } =
      toRefs(props)
    const component = computed(() => {
      return attrs.href ? GaLinkBase : GaButtonBase
    })

    const state = computed(() => {
      switch (true) {
        case disabled.value:
          return STATE.DISABLED
        case loading.value:
          return STATE.LOADING
        default:
          return STATE.DEFAULT
      }
    })

    const disabledInternal = computed(() => {
      return [STATE.DISABLED, STATE.LOADING].includes(state.value)
    })

    const mods = computed(() => {
      const modsInternal = {
        view: view.value,
        size: size.value,
        'icon-size': iconSize.value,
        state: state.value,
        round: round.value,
      }

      if (view.value === VIEW.LINE) {
        return { ...modsInternal, 'border-width': borderWidth.value }
      }

      return modsInternal
    })

    return {
      component,

      disabledInternal,

      mods,
    }
  },
}
